import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { authAPI } from '@/lib/api/auth';
import { AuthLayout } from '@/layouts/AuthLayout';
import { VStack } from '@/components/core';

export default function ResetPasswordRequest() {
  const { t } = useTranslation('auth');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage(null);
    try {
      await authAPI.forgotPassword(email);
      setMessage(t('passwordReset.requestSuccess', 'Wenn die E-Mail existiert, senden wir einen Link.'));
    } catch {
      setMessage(t('passwordReset.requestSuccess', 'Wenn die E-Mail existiert, senden wir einen Link.'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout>
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>{t('passwordReset.title', 'Passwort zurücksetzen')}</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit}>
            <VStack gap="md">
              <Input
                type="email"
                placeholder={t('login.emailPlaceholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              {message && (
                <div className="text-sm text-muted">{message}</div>
              )}
              <Button type="submit" disabled={isLoading} className="w-full">
                {isLoading ? t('common:buttons.loading') : t('passwordReset.sendLink', 'Link senden')}
              </Button>
            </VStack>
          </form>
        </CardContent>
      </Card>
    </AuthLayout>
  );
}
